// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bd-4";
export var collapsed = "_bd-1";
export var headerBar = "_bd-0";
export var leftHeaderContent = "_bd-3";
export var subjectContainer = "_bd-2";